import { enqueueSnackbar } from 'notistack';
import { formatDate } from 'src/components/utils/format-time';
import { toExcel } from 'to-excel';

// Set headers
const headers = [
  { label: 'Nexudus User ID', field: 'account.nexudus_id' },
  { label: 'Coworker', field: 'account.profile_url' },
  { label: 'Amount', field: 'item_amount' },
  { label: 'Additional Services', field: 'additional_services' },
  { label: 'Requested Date', field: 'created_at' },
  { label: 'Status', field: 'status' },
  { label: 'Last seen', field: 'last_seen' },
  { label: 'Requested Item', field: 'inventory.name' },
  { label: 'Purchased Item', field: 'inventory.name' },
  { label: 'Purchase Date', field: 'purchase_date' },
];

export const DownloadExcel = (myList) => {
  const formattedList = myList.map((row) => ({
    ...row,
    created_at: formatDate(row?.created_at),
    last_seen: formatDate(row?.last_seen),
    purchase_date: formatDate(row?.purchase_date),
  }));

  const content = toExcel.exportXLS(headers, formattedList, 'filename');

  const blob = new Blob([content], { type: 'application/vnd.ms-excel' });

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'filename.xls';

  document.body.appendChild(a);

  a.click();

  document.body.removeChild(a);
  URL.revokeObjectURL(url);

  enqueueSnackbar('Requests exported successfully', { variant: 'success' });
};
